import classes from './TechStack.module.scss'
import { useRef } from 'react'

const TechStack = () => {
  const imagesLoadedCountRef = useRef(0)

  const logos = [
    'Javascript.svg',
    'Html.svg',
    'Css.svg',
    'Sass.svg',
    'Typescript.svg',
    'React.svg',
    'Redux.svg',
    'Angular.svg',
    'Mongo.svg',
    'Node.svg',
    'Tailwind.svg',
    'Bootstrap.svg',
    'Bulma.svg',
    'Strapi.svg',
    'Figma.svg',
  ]
  const handleImageLoad = () => {
    imagesLoadedCountRef.current += 1

    // Check if all images have loaded
    if (imagesLoadedCountRef.current === logos.length) {
      // If a user hasn't opted in for reduced motion, then we add the animation

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        addAnimation()
      }
    }
  }

  const addAnimation = () => {
    const scrollers = document.querySelectorAll(`.${classes.scroller}`)
    scrollers.forEach((scroller) => {
      // Add data-animated="true" to every `.scroller` on the page
      scroller.setAttribute('data-animated', true)

      // Make an array from the elements within `.scroller-inner`
      const scrollerInner = scroller.querySelector(`.${classes.scroller_inner}`)
      const scrollerContent = Array.from(scrollerInner.children)

      scrollerContent.forEach((item) => {
        if (item.tagName.toLowerCase() === 'li') {
          const duplicatedItem = item.cloneNode(true)
          duplicatedItem.setAttribute('aria-hidden', true)
          scrollerInner.appendChild(duplicatedItem)
        }
      })
    })
  }

  return (
    <div className={classes.scroller}>
      <ul className={`${classes.scroller_tech_list} ${classes.scroller_inner}`}>
        {logos.map((img, index) => {
          return (
            <li key={index}>
              <img
                src={`/images/logos/${img}`}
                alt={`${img.split('.')[0]} logo`}
                onLoad={handleImageLoad}
              />
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default TechStack
